import { ResourceHistoryEntity } from '../../../model/ResourceHistory'

const all = ['resourceHistory']
const lists = [...all, 'list']
const list = ({ id, type, excludeEventType }: ResourceHistoryEntity) => [
  ...lists,
  type,
  id,
  excludeEventType,
]

export const resourceHistoryKeys = {
  all,
  lists,
  list,
}
